import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TuiButton, TuiHint, TuiInput } from '@taiga-ui/core';
import { WorkflowFormFieldInputButton } from '@workflows/types';

@Component({
  selector: 'x-input-button-field',
  imports: [CommonModule, ReactiveFormsModule, TuiInput, TuiHint, TuiButton],
  templateUrl: './input-button-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class InputButtonFieldComponent {
  field = input.required<WorkflowFormFieldInputButton>();
  control = input.required<FormControl<string | null>>();
  canExecute = input<boolean>(true);
}
